import { RegisterScreen } from "../auth/RegisterScreen"
import { ProductAddScreen } from "./panelComponents/productsPanel/ProductAddScreen"
import { ProductsAllScreen } from "./panelComponents/productsPanel/ProductsAllScreen"
import { SellDonePanel } from "./panelComponents/SellPanel/SellDonePanel"
import { SellPendingPanel } from "./panelComponents/SellPanel/SellPendingPanel"
import { StockOff } from "./panelComponents/SellPanel/StockOff"

import { UsersAllScreen } from "./panelComponents/usersPanel/UsersAllScreen"
import { WelcomeScreen } from "./panelComponents/WelcomeScreen"

export const PanelScreen = ({selectPanel}) => {

    

    

  return (
    <div className=' panel-conteiner'>

        {/* WELCOME */}

        <div className={selectPanel ?  'ocult' : ''}>
            <WelcomeScreen />
        </div>

        {/* USER */}

        <div className={selectPanel === 'user' ? 'tab-content' : 'ocult'} id="pills-tabContent1">

            <div className="tab-pane fade show active " id="pills-Usuarios" role="tabpanel" aria-labelledby="Usuarios">

            <UsersAllScreen />
            </div>

            <div className="tab-pane fade" id="pills-UserAdd" role="tabpanel" aria-labelledby="UserAdd">
                
            <RegisterScreen />
            </div>

        </div>
    

        {/* PRODUCTS */}


        <div className={selectPanel === 'product' ? 'tab-content' : 'ocult'}  id="pills-tabContent2">

            
            <div className="tab-pane fade show active"  id="pills-Products" role="tabpanel" aria-labelledby="Products">

                <ProductsAllScreen />
            </div>
            <div className="tab-pane fade" id="pills-ProductsAdd" role="tabpanel" aria-labelledby="ProductsAdd">
                
                <ProductAddScreen />
            </div>


        </div>


            {/* PEDIDOS  */}

        <div className={selectPanel === 'pedidos' ? 'tab-content' : 'ocult'}  id="pills-tabContent3">

                                        
            <div className="tab-pane fade "  id="pills-Entregas" role="tabpanel" aria-labelledby="Entregas">

                <SellDonePanel />
            </div>
            <div className="tab-pane fade show active" id="pills-Encargos" role="tabpanel" aria-labelledby="Encargos">
                
                <SellPendingPanel />
            </div>
            <div className="tab-pane fade show " id="pills-Stockoff" role="tabpanel" aria-labelledby="Stockoff">
                
                <StockOff />
            </div>


        </div>
        


    </div>

  )
}
